import { ReactNode } from 'react';
import { Route } from 'react-router-dom';
import { RoutesExtensionInterface } from '../../../../extension/interface/routes.extension.interface';
import CarConnectPage from '../../../../page/car/CarConnectPage';
import CarLearnMorePage from '../../../../page/car/CarLearnMorePage';
import CarSettingsPage from '../../../../page/car/CarSettingsPage';

export class CarRoutesExtension extends RoutesExtensionInterface {
  get privateRoutes(): ReactNode {
    return (
      <>
        <Route path="/benefits/car/connect" element={<CarConnectPage />} />
        <Route path="/benefits/car/learnMore" element={<CarLearnMorePage />} />
        <Route path="/benefits/car/settings" element={<CarSettingsPage />} />
      </>
    );
  }
}
